<template>
  <div class="about-us">
    <!-- Hero Section -->
    <section class="about-us__hero">
      <h1>{{ t('aboutUs.hero.title') }}</h1>
      <p class="hero-text">
        {{ t('aboutUs.hero.text') }}
      </p>
    </section>

    <!-- Story Section -->
    <section class="about-us__story">
      <div class="story-container">
        <h2>{{ t('aboutUs.story.title') }}</h2>
        <!-- Historie -->
        <div class="story-item">
          <div class="icon-left">
            <div class="icon-section">
              <div class="icon-container">
                <img :src="historikIcon" alt="Historie icon">
              </div>
              <h3>{{ t('aboutUs.story.history.title') }}</h3>
            </div>
          </div>
          <div class="text-right">
            <div class="content">
              <p>
                {{ t('aboutUs.story.history.text') }}
              </p>
            </div>
          </div>
        </div>

        <!-- Mission -->
        <div class="story-item">
          <div class="text-left">
            <div class="content">
              <p>
                {{ t('aboutUs.story.mission.text') }}
              </p>
            
            </div>
          </div>
          <div class="icon-right">
            <div class="icon-section">
              <div class="icon-container">
                <img :src="missionIcon" alt="Mission icon">
              </div>
              <h3>{{ t('aboutUs.story.mission.title') }}</h3>
            </div>
          </div>
        </div>

        <!-- Vision -->
        <div class="story-item">
          <div class="icon-left">
            <div class="icon-section">
              <div class="icon-container">
                <img :src="visionIcon" alt="Vision icon">
              </div>
              <h3>{{ t('aboutUs.story.vision.title') }}</h3>
            </div>
          </div>
          <div class="text-right">
            <div class="content">
              <p>
                {{ t('aboutUs.story.vision.text') }}
              </p>
            </div>
          </div>
        </div>

        <!-- Værdier -->
        <div class="story-item">
          <div class="text-left">
            <div class="content">
              <p v-html="t('aboutUs.story.values.text')"></p>
            </div>
          </div>
          <div class="icon-right">
            <div class="icon-section">
              <div class="icon-container">
                <img :src="valuesIcon" alt="Værdier icon">
              </div>
              <h3>{{ t('aboutUs.story.values.title') }}</h3>
            </div>
          </div>
        </div>

      </div>
    </section>

    <!-- Services Section -->
    <section class="about-us__services">
      <h2>{{ t('aboutUs.services.title') }}</h2>
      <div class="services-grid">
        <div class="service-card">
          <img :src="rapporterIcon" alt="Rapporter icon">
          <h3>{{ t('aboutUs.services.dataCollection.title') }}</h3>
          <p>{{ t('aboutUs.services.dataCollection.text') }}</p>
        </div>
        <div class="service-card">
          <img :src="historiskIconService" alt="Historisk icon">
          <h3>{{ t('aboutUs.services.timeOptimization.title') }}</h3>
          <p>{{ t('aboutUs.services.timeOptimization.text') }}</p>
        </div>
        <div class="service-card">
          <img :src="intuitivtIconService" alt="Intuitivt icon">
          <h3>{{ t('aboutUs.services.decisionMaking.title') }}</h3>
          <p>{{ t('aboutUs.services.decisionMaking.text') }}</p>
        </div>
      </div>
      <p class="services-footer">
        {{ t('aboutUs.services.footer') }}
      </p>
    </section>

    <!-- CTA Section -->
    <section class="about-us__cta">
      <h2>{{ t('aboutUs.cta.title') }}</h2>
      <p>{{ t('aboutUs.cta.text') }}</p>
      <div class="cta-buttons">
        <TextWithArrowButton :text="t('aboutUs.cta.button')" @click="$router.push('/kontakt', { query: { subject: 'Book møde/opkald' }})" />
      </div>
    </section>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import TextWithArrowButton from '@/components/TextWithArrowButton.vue'
import historikIcon from '@/assets/images/icons/historik_light.svg'
import missionIcon from '@/assets/images/icons/mission_light.svg'
import visionIcon from '@/assets/images/icons/vision_light.svg'
import valuesIcon from '@/assets/images/icons/values_light.svg'
import rapporterIcon from '@/assets/images/icons/rapporter.svg'
import historiskIconService from '@/assets/images/icons/historisk.svg'
import intuitivtIconService from '@/assets/images/icons/Intuitivt.svg'

const { t } = useI18n()
</script>

<style scoped>
.about-us {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

section {
  margin-bottom: 4rem;
}

.about-us__hero {
  text-align: center;
  padding: 3rem 0;
}

h1 {
  font-family: 'Darker Grotesque', sans-serif;
  font-size: 3rem;
  color: var(--primary-text-color);
  margin-bottom: 1.5rem;
}

h2 {
  font-family: 'Darker Grotesque', sans-serif;
  font-size: 2rem;
  color: var(--primary-text-color);
  margin-bottom: 1.5rem;
}

.hero-text {
  font-size: 1.2rem;
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
  color: var(--grey);
  font-family: 'Darker Grotesque', sans-serif;
}

.about-us__story {
  background-color: var(--dark-red-element);
  color: var(--white);
  padding: 4rem 4rem;
  margin: 4rem -0.5rem;
  border-radius: 12px;
  font-family: 'Darker Grotesque', sans-serif;
}

.story-container {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.story-container h2 {
  font-size: 2rem;
  color: var(--white);
  margin-bottom: 1.5rem;
}

.story-item {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 3rem 0;
}

.icon-left, .icon-right {
  flex: 0 0 15%;
}

.icon-left {
  display: flex;
  justify-content: flex-start;
}

.icon-right {
  display: flex;
  justify-content: flex-end;
}

.text-left, .text-right {
  flex: 0 0 85%;
}

.icon-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-container {
  height: 100px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: -1rem;
}

.icon-container img {
  height: 60px;
  width: 60px;
}

.icon-section h3 {
  color: var(--white);
  font-size: 2rem;
  font-family: 'Darker Grotesque', sans-serif;
  margin: 0;
}

.content {
  width: 100%;
}

.content p {
  line-height: 1.6;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
}

.service-card {
  background: var(--card-background);
  padding: 2rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 4px var(--shadow-color);
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-card i {
  font-size: 2rem;
  color: var(--primary-text-color);
  margin-bottom: 1rem;
}

.service-card img {
  width: 40px;
  height: 40px;
  margin-bottom: 1rem;
}

.service-card h3 {
  color: var(--primary-text-color);
  margin-bottom: 1rem;
  font-family: 'Darker Grotesque', sans-serif;
}

.service-card p {
  color: var(--primary-text-color);
}

.services-footer {
  text-align: center;
  margin-top: 2rem;
  color: var(--grey);
}

.about-us__cta {
  text-align: center;
  padding: 3rem;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
}

@media (max-width: 768px) {
  .about-us {
    padding: 1rem;
  }

  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.5rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }

  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }

  .story-item {
    flex-direction: column;
    gap: 2rem;
    text-align: center;
  }

  .icon-left, .icon-right, .text-left, .text-right {
    width: 100%;
    flex: auto;
    justify-content: center;
    text-align: center;
  }

  .icon-section {
    margin: 0 auto;
  }
}
</style>
